var _path, _circle, _circle2, _circle3, _path2, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _path3, _path4, _path5, _circle10, _circle11, _circle12, _path6, _path7, _circle13, _polygon, _path8, _polygon2, _path9, _path0, _circle14, _path1, _circle15, _path10, _circle16, _path11, _path12, _circle17, _circle18, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 926.63239,
    height: 785.99373,
    viewBox: "0 0 926.63239 785.99373",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1030.88654,386.0594c-46.33985,59.26-133.78028,72.83-206.12989,52.19a335.51025,335.51025,0,0,1-68.1001-28.35c-12.54-6.81-24.77978-14.28-36.77-22.24-2.9502-1.95-5.89991-3.93-8.81983-5.95q-2.98534-2.04-5.95019-4.12994c-24.76026-17.42-48.54981-36.53-71.94-55.53-58.39013-47.43-118.37988-96.32-190.12011-118.95-14.77979-4.66-33.89991-6.84-43.04,5.68-7.92969,10.87-3.08985,26.26,3.62012,37.92005,24.89013,43.19,70.06982,70.46,115.29,91.43,45.21973,20.97,93.12012,37.96,132.42969,68.62,39.31006,30.66,69.32031,79.39,61.28028,128.58-6.93018,42.39-41.54,76.83-81.78028,91.84-40.23974,15-85.11963,12.91-126.94971,3.17-41.83007-9.75-81.54-26.76-121.91015-41.42-24.33985-8.85-56.15967-14.97-72.31006,5.28-13.63965,17.11-5.7998,44.1,10.81006,58.34s39.09033,19.01,60.54,23.29q99.90015,19.95,199.80029,39.89c20.42969,4.07,41.33984,8.33,59.13965,19.17,17.80029,10.83,32.16016,29.75,31.65039,50.58-.51025,20.53-15.54,38.67-33.96045,47.76-18.40967,9.08-39.66992,10.48-60.17969,9.5-76.85986-3.68-297.21-125.79-350.06006-141.4-33.96-10.02-71.08984-24.74-85.41015-57.12006-17.83008-40.31,11.51025-89.07995,51.56006-107.49,40.04-18.42,86.46-14.34,130.10009-8.13995,43.64014,6.19995,88.71973,14.09,131.2002,2.31,42.47949-11.78,81.3999-50.18006,77.21-94.06-3.65039-38.18005-38.04-66.95-74.23047-79.63-28.32959-9.93-58.46972-12.63-88.22949-17.1-8.26025-1.23-16.49023-2.61-24.64014-4.31a307.086,307.086,0,0,1-60.75-19.5,312.92391,312.92391,0,0,1-58.04-33.31,305.265,305.265,0,0,1-40.31982-35.01q-2.83521-2.93994-5.61035-6.01c-1.75977-1.96-3.5-3.96-5.19971-6-22.12012-26.43-38.46045-58.98-33.56006-92.51995,4.88965-33.45,30.96-61.3,62-74.68,17.93994-7.73,37.29-11.19,56.87989-11.69a233.79559,233.79559,0,0,1,42.77978,3.08c65.41016,10.46,125.3501,42.24005,181.96045,76.65,56.59961,34.41,111.75977,72.18,173.28955,96.71,61.53027,24.54,131.57031,34.93,193.99023,12.74,62.41993-22.18,113.69971-82.7,110.64991-148.87,41.3999,35.65,76.58008,80.46,92.16015,132.82C1070.79669,282.5594,1064.53644,343.01942,1030.88654,386.0594Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 595.91072,
    cy: 253.39374,
    r: 7.27771,
    fill: "#23ce6b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.91072,
    cy: 157.39374,
    r: 11.25197,
    fill: "#ff6584"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.91072,
    cy: 511.39374,
    r: 4.15748,
    fill: "#ff6584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370.92657,329.39937a44.42971,44.42971,0,0,1-1.2998,10.7c-8.26025-1.23-16.49023-2.61-24.64014-4.31a307.086,307.086,0,0,1-60.75-19.5,44.3374,44.3374,0,0,1,86.68994,13.11Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#ff6584"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.91072,
    cy: 230.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.91072,
    cy: 698.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.91072,
    cy: 757.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.91072,
    cy: 589.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.91072,
    cy: 510.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.91072,
    cy: 88.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 520.91072,
    cy: 421.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.91072,
    cy: 495.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.52716,220.72761q9.0747-2.73879,17.36182-5.93548c33.96045-13.11719,53.438-30.91113,53.438-48.82031s-19.47753-35.70313-53.438-48.82032q-5.0376-1.94568-10.38575-3.72345a136.34021,136.34021,0,0,1-6.97607,107.29956Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.32648,158.96937a135.44,135.44,0,0,1-14.79981,61.76q-1.93506,3.78-4.1001,7.43a136.43138,136.43138,0,0,1-61.23,54.82,305.26946,305.26946,0,0,1-40.31982-35.01q-2.83521-2.94-5.61035-6.01c-1.75977-1.96-3.5-3.96-5.19971-6-22.12012-26.43-38.46045-58.98-33.56006-92.51995,4.88965-33.45,30.96-61.30005,62-74.68006,17.93994-7.73,37.29-11.18994,56.87989-11.68994a136.1263,136.1263,0,0,1,35.33007,49.16c1,2.37,1.91993,4.77,2.79,7.2A135.75647,135.75647,0,0,1,306.32648,158.96937Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#23ce6b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M368.32648,165.96937c0,20.83-20.33985,40.15-57.27979,54.42-7.39014,2.86-15.30029,5.45-23.62012,7.77-31.14013,8.68-68.20019,13.49-107.16015,13.8-1.75977-1.96-3.5-3.96-5.19971-6,.41992.01.83984.01,1.25977.01,42.31006,0,82.45019-5.36,115.20019-15.24,6.04981-1.83,11.8501-3.81,17.35987-5.94,33.96-13.11,53.43994-30.91,53.43994-48.82,0-17.91-19.48-35.7-53.43994-48.82q-5.03981-1.95-10.37989-3.72c-.87011-2.43-1.79-4.83-2.79-7.2q7.97975,2.49,15.33008,5.32C347.98663,125.81935,368.32648,145.14937,368.32648,165.96937Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#e4e4e4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.91072,
    cy: 30.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.91072,
    cy: 57.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.91072,
    cy: 100.39374,
    r: 41.34843,
    fill: "#f0f0f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M989.19659,376.23939c-9.28027,2.74-29.74023,4.76-52.24023,6-22.48975,1.23-47.15967,1.77-71.52,2.29q-63.95947,1.38008-127.90967,2.77-8.79052.195-17.64013.36c-2.9502-1.95-5.89991-3.93-8.81983-5.95,5.23.03,10.46,0,15.6499-.1,22.16993-.44,40.93994-2.17,62.31983-2.99,32.8999-1.27,68.41992-.27,102.71.24C926.03644,379.37941,965.10626,379.18941,989.19659,376.23939Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#f0f0f0",
    opacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M334.76739,691.47011,198.8465,578.23939,330.89142,696.00551a3.15089,3.15089,0,1,0,3.876-4.5354Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#f0f0f0",
    opacity: 0.3
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.91072,
    cy: 201.39374,
    r: 4.25197,
    fill: "#f0f0f0"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "452.017 694.074 469.604 694.073 477.971 626.236 452.014 626.237 452.017 694.074",
    fill: "#ffb6b6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M584.21461,745.3347l4.95031-.0002,19.32677-7.85976,10.35857,7.85856h.0014a22.07371,22.07371,0,0,1,22.07254,22.07219v.71727l-56.70854.0021Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.308 694.074 302.721 694.073 294.354 626.236 320.311 626.237 320.308 694.074",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M461.47733,768.12486l-56.70854-.0021v-.71727a22.07373,22.07373,0,0,1,22.07255-22.07219h.0014l10.35856-7.85856,19.32678,7.85976,4.9503.0002Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#2f2e41"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M520.00914,231.19113,502.20127,244.7512,454.89616,257.279s16.95034,118.9604,8.95034,126.9604-.785,8.215-2.3925,18.60751-8.0134,37.83062-8.0134,37.83062l141.18774,0s1.13768-17.05233-5.82208-20.74524,6.41582-20.92914.728-23.811,2.31221-27.88189,2.31221-27.88189l17.33726-81.84953-46.11409-36.07971-7.01323-16.89753Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#23ce6b"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 405.54518,
    cy: 274.32837,
    r: 6.16142,
    fill: "#f2f2f2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M453.4406,440.67752l-5.82221,149.921S422.47986,701.32826,426.8465,704.23939s6.21647,20.26918,6.21647,20.26918l24.74427,2.91107s0-11.64434,5.8222-16.011,59.67731-209.59827,59.67731-209.59827l52.53975,198.429s1.31535,11.16933,5.682,11.16933,5.8222,16.011,5.8222,16.011h24.7442v-16.011s11.11824-3.525,6.75161-15.16933-24.21816-255.56184-24.21816-255.56184Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#2f2e41"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.81722,
    cy: 135.41526,
    r: 29.83864,
    fill: "#ffb6b6"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "452.85 269.414 458.672 273.781 461.583 253.403 452.85 269.414",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M457.68656,257.16325s-7.27771-1.45554-11.64435,11.64435-20.37763,62.58838-20.37763,71.32162S525.37479,387.396,525.37479,387.396L515,351l-45.66916-23.97063Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#23ce6b"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.3162,
    cy: 307.99686,
    r: 17,
    fill: "#ffb6b6"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.316 251.997 332.647 270.026 374.878 292.192 337.316 266.997 331.316 251.997",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M569.523,311.57037h-.54786V296.5621a8.68635,8.68635,0,0,0-8.68634-8.6864H528.49175a8.68638,8.68638,0,0,0-8.68641,8.68637v82.33658a8.68636,8.68636,0,0,0,8.68634,8.6864h31.79706a8.68638,8.68638,0,0,0,8.6864-8.68637V322.25354h.54786Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#f0f0f0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M609.18376,286.38986s4.36664,2.9111,7.27771,16.011,21.83313,62.58838,14.55542,74.23273-9.42613,24.07235-34.17039,6.60582l-34.24019-31.35005,24.74426-23.2887,10.18878,7.27771Z",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#23ce6b"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.09493,
    cy: 260.29233,
    r: 7.27771,
    fill: "#23ce6b"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.16269,
    cy: 276.23626,
    r: 17,
    fill: "#ffb6b6"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "330.514 306.41 379.316 327.997 329.158 318.194 330.514 306.41",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M508.39724,198.36486,504.30036,182.773c-1.069-4.06825-2.1468-8.2188-1.90666-12.41829s2.02153-8.53306,5.55953-10.80812,8.93887-1.73765,11.21552,1.79934c.43269-5.6477,5.57051-9.99191,11.02167-11.5309s11.23883-.93036,16.89712-.67071,11.63086.07839,16.51434-2.79133a5.11236,5.11236,0,0,1-2.289,6.0413,4.96273,4.96273,0,0,0,5.99526-3.162,12.87951,12.87951,0,0,1-3.38121,8.84533A9.47453,9.47453,0,0,1,576.173,161.5452c2.49223,4.32072,1.09576,9.747-.36235,14.5171l-7.48376,24.48244c-1.13493-3.72175-1.349-7.651-1.95614-11.49426s-1.68723-7.76808-4.22427-10.71815-6.84639-4.65853-10.45111-3.19377c-2.02248.82183-3.56457,2.4891-5.39049,3.68569-3.74646,2.45519-8.512,2.80734-12.96327,2.30773s-8.789-1.76713-13.2396-2.27343c-2.78658-.317-5.89639-.23309-7.9989,1.623a10.28106,10.28106,0,0,0-2.73826,5.46723,43.4859,43.4859,0,0,0-1.158,12.5407",
    transform: "translate(-136.6838 -57.00314)",
    fill: "#2f2e41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.cf4b7a67f23b684549c4f797c62b527a.svg";
export { ForwardRef as ReactComponent };